import $ from 'jquery';
import Swiper from 'swiper';
import "swiper/css/swiper.css";
import inView from 'in-view';

const render = () => {
    var mySwiper = new Swiper ('.mySwiper', {
        loop: true,
        speed:1000,
        autoplay : {
            delay:3000
        },
        slidesPerView: 'auto',
        spaceBetween: 30,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    /**
     *  freelink 模块轮播
     * */
    var mySwiper2 = new Swiper('.mySwiper1', {
        loop: true, // 循环模式选项
        speed:1000,
        autoplay : {
            delay:3000
        },
        slidesPerView: 'auto',
        spaceBetween: '10%',
        centeredSlides: true,
        breakpoints: {
            1400: {
                slidesPerView: 3,
                spaceBetween: 60,
            },
            320: {
                slidesPerView: 'auto',
                loopedSlides: 3,
                spaceBetween: 40,
            }
        },

    });

    inView('.card-img').on('enter', scrollAnimation);

    function scrollAnimation() {
        const cardImg = $('.card-img');
        cardImg.addClass('move');
    }


};
render();